import { useSelector } from "react-redux";
import get from "lodash/get";

const useData = (resource, id) => {
  return useSelector(
    (state) => state?.resources?.[resource]?.data?.[id] || null
  );
};

const useIsLoading = (resource, id) => {
  return useSelector(
    (state) => state?.resources?.[resource]?.loading?.[id] || false
  );
};

export const useResourceInstance =  (resource, id) => {
  const record = useData(resource, id);
  const isLoading = useIsLoading(resource, id);
  const version = useSelector((state) => state?.ui?.viewVersion || 0);

  return {
    record,
    isLoading,
    version,
  };
};

